// import create from 'zustand/vanilla'
import { Memory } from '@ow/lowdb'
import { getEnvConfig, setAMapSecurityConfig } from '@vt/utils'
import { assign } from 'lodash-es'
import { createLowDB } from '@vt/models'

import { setApiVersion, setApiVersionH, setHttpClient } from '@vt/apis/lib-ex'
import LowWithLodash from './low-with-lodash'
import defaultModels from './default-models'

// 兼容旧的 api
function configureApi(httpAdapter, API_VERSION, API_VERSION_H) {
  setHttpClient(httpAdapter)
  setApiVersion(API_VERSION)
  setApiVersionH(API_VERSION_H)
}

const ENV = process.env.REACT_APP_DEP || 'dev'

const appName = (appId) => `voltali_${ENV}_${appId}`

class VtProjectStarter {
  constructor({ platformData, customInfo = {}, offline }) {
    this.platformData = platformData
    this.dittos = {}
    this.caches = {}
    this.dbs = {}
    this.apps = {}
    this.customInfo = customInfo
    this.offline = offline
    // window.vt = this
  }

  get defaultCofing() {
    return getEnvConfig(this.platformData)
  }

  configureApi(httpAdapter) {
    this.http = httpAdapter
    // this.reConfigureModels()
  }

  configureModels(models) {
    this.models = Object.assign(defaultModels, models)
    // this.models = models || defaultModels
    // this._is_models_configured = true
  }

  offlineFetcher(type, opts, defaultVal) {
    console.log(this.offline)
    return defaultVal
  }

  // reConfigureModels() {
  //   if (this._is_models_configured) {
  //     this._is_models_configured = false
  //     this.configureModels(this.models)
  //   }
  // }

  // initStore() {
  //   this.store = create((set) => ({
  //     setToken: (token) => {
  //       set(() => ({ token }))
  //     },
  //   }))
  // }

  // 拆分 init 为 configureDB

  // 一个项目会有n个数据库：
  // 1、一个是project的数据库比如叫 project_db
  // 2、剩余的 n-1个是不同 app 用的比如叫 app_db_appid

  // 此外：
  // 1、project_db 存的是token，项目设置这些项目级别的数据，一个项目只有一个
  //    这个我们可以固定用 lowdbwithlodash 来存（但是可以用不同的adaptor）
  //    一个项目可以有多个 app，每个app都有自己的 appid，
  // 2、app_db_appid 存了app下的表单和表单数据，这个就可以根据不同的平台来用不用的数据库
  //    比如 web可以用 pouch，小程序还可以用 lowdb，这个是通过 createDittoDb 传进来的

  // @lowAdapter 用来传递 project_db 创建时用的 lowdb adaptor
  // @httpAdapter http client 的 adaptor，可选的 adaptor 在 vt-utils/lib/http
  // @createDittoDB 是 app_db_appid 创建时用的方法，这个是在 vt-models 封装的

  // TODO: 需要改一下 LowWithLodash 的初始化，这里可能要把项目的名称传进去，作为数据库名字，
  // 不然如果部署在同一个域名的不同项目可能会冲突
  // 当然 memory adaptor 就没这个问题，所以之前也没传名字，名字可以从环境变量获取，打印下 process.env 看看
  // project_db: ${project_name}_${env: dev | prod ...}

  async init({
    config,
    lowAdapter,
    httpAdapter,
    models,
    createDittoDB,
    amapKey,
  }) {
    const finalConfig = config || this.defaultCofing

    const DBadapter = lowAdapter || new Memory()

    this.db = new LowWithLodash(DBadapter, '')
    this.createDittoDB = createDittoDB || createLowDB

    await this.db.read()

    if (!this.db.data) {
      this.db.data = { config: finalConfig }
    }
    this.config = config
    this.amapKey = amapKey

    // this.initStore()

    configureApi(
      httpAdapter,
      finalConfig.API_VERSION,
      finalConfig.API_VERSION_H
    )
    this.configureApi(httpAdapter)
    this.configureModels(models || {})
    setAMapSecurityConfig()
  }

  getToken() {
    return this.token
  }

  setToken(token) {
    this.token = token
    return token
  }

  getUserInfo() {
    return this.userInfo
  }

  setUserInfo(userInfo) {
    this.userInfo = userInfo
    return userInfo
  }

  getCusKey() {
    return this.cusKey
  }

  setCusKey(cusKey) {
    this.cusKey = cusKey
    return cusKey
  }

  getUserInfoInApp() {
    return this.userInfoInApp
  }

  setUserInfoInApp(userInfoInApp) {
    this.userInfoInApp = userInfoInApp
  }

  deleteUserInfoInApp() {
    delete this.userInfoInApp
  }

  /**
   * 获取storage存储内容
   * @param {*} key 存储key
   * @returns
   */
  getStorage(key) {
    return this.db.data[key]
  }

  /**
   * 设置storage存储内容
   * @param {*} param { key, data } 以对象方式传递
   * @returns
   */
  setStorage({ key, data }) {
    this.db.data[key] = data
    this.db.write()
  }

  /**
   * 删除storage存储内容
   * @param {*} key 存储key，为空则清空storage
   * @returns
   */
  deleteStorage(key) {
    if (key) {
      delete this.db.data[key]
    } else {
      this.db.data = {}
    }
    this.db.write()
  }

  getDittoDBByAppId(appId) {
    const app = this.getApp(appId)
    if (!app.db) {
      app.db = this.createDittoDB(appId)
    }
    return app.db
  }

  // 获取某个项目的缓存
  // getCachesByAppId(appId) {
  //   if (this.caches[appId]) {
  //     return this.caches[appId]
  //   }
  //   this.caches[appId] = {}
  //   mapValues(this.models.refs, (Model) => {
  //     this.caches[appId][Model.modelName] = new Model(
  //       appId,
  //       this.getDittoDBByAppId(appId)
  //     )
  //   })
  //   return this.caches[appId]
  // }

  setApp(appId, opts) {
    const app = this.getApp(appId)
    this.apps[appName] = assign(app, opts)
  }

  getApp(appId) {
    if (!this.apps[appName(appId)]) {
      this.apps[appName(appId)] = {
        dittos: {},
      }
    }
    return this.apps[appName(appId)]
  }

  getDitto(appId, tbNameId) {
    const app = this.getApp(appId)

    if (!app.dittos[tbNameId]) {
      // ProjectConfig 也传进去
      // const ditto = new models.DittoModel(ProjectConfig, tbDefs, db, caches)

      const isDitto =
        !!app.tbs[tbNameId] &&
        ![
          'user',
          'area',
          'org',
          'standard',
          'punchIn',
          'footPrinter',
          'video',
        ].includes(tbNameId)
      let DittoModel = null

      if (isDitto) {
        DittoModel = this.models.ditto
      } else {
        DittoModel = this.models[tbNameId]
      }

      if (DittoModel) {
        const ditto = new DittoModel(appId, tbNameId, this)
        app.dittos[tbNameId] = ditto
        return ditto
      }
      return null
      // const DittoModel = this.models[tbName] || this.models.ditto
      // const ditto = new DittoModel(appId, tbName, this)
      // app.dittos[tbName] = ditto
      // return ditto
    }
    return app.dittos[tbNameId]
  }
}

export default VtProjectStarter
